
export const GRAPH_API = process.env.GRAPH_API ? process.env.GRAPH_API : 'https://api.fertigteilhausversicherung.at/graphql';
//export const GRAPH_API = 'http://localhost:3000/graphql';
export const API_PATH = process.env.API_PATH ? process.env.API_PATH : 'https://m4oh5e9agk.execute-api.eu-central-1.amazonaws.com/prod';
export const API_KEY = 'UGgQ1ajojN1fx2046yG9FabpQ68RCHIg42RlsmGw';
export const VERSION = '1.2.7'
export const PRISMIC_KEY = 'MC5YMEFsakJBQUFDVUFfMjV3.77-977-977-977-9Kjbvv73vv73vv73vv73vv73vv70c77-977-9Kl5j77-9TGHvv73vv73vv71I77-9F--_vSN8Ju-_vQ'
export const PRISMIC_PATH = 'https://fertigteilhausversicherung.cdn.prismic.io/api/v2'
